import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "focus-visible:ring-ring-default inline-flex shrink-0 items-center justify-center gap-2 rounded-full text-sm font-medium whitespace-nowrap transition-all outline-none focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50 data-[loading=true]:cursor-not-allowed [&>svg]:pointer-events-none [&>svg]:shrink-0 [&>svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        default:
          "bg-shape-neutral-outlined-background border-shape-neutral-outlined-border-default text-shape-neutral-outlined-foreground-default hover:bg-shape-neutral-outlined-background-hover hover:text-shape-neutral-outlined-foreground-default-hover active:bg-shape-neutral-outlined-background-pressed data-[loading=true]:bg-shape-neutral-outlined-background-pressed border shadow-xs",
        emphasised:
          "bg-shape-neutral-inverted-background text-shape-neutral-inverted-foreground-default hover:bg-shape-neutral-inverted-background-hover active:bg-shape-neutral-inverted-background-pressed data-[loading=true]:bg-shape-neutral-inverted-background-pressed shadow-xs",
        muted:
          "bg-shape-neutral-ghost-background text-shape-neutral-ghost-foreground-default hover:bg-shape-neutral-ghost-background-hover hover:text-shape-neutral-ghost-foreground-default-hover active:bg-shape-neutral-ghost-background-pressed data-[loading=true]:bg-shape-neutral-ghost-background-pressed",
        ghost:
          "text-shape-neutral-ghost-foreground-default hover:bg-shape-neutral-ghost-background-hover hover:text-shape-neutral-ghost-foreground-default-hover active:bg-shape-neutral-ghost-background-pressed data-[loading=true]:bg-shape-neutral-ghost-background-pressed bg-transparent",
        // `ghost` one step down the neutral ladder on hover, for a control that sits
        // ON a surface already painted with the shared hover token (a sortable table
        // header inside a hovered row): `ghost` hovers to the same value as that
        // surface, so it would show no feedback of its own there.
        "ghost-emphasised":
          "text-shape-neutral-ghost-foreground-default hover:bg-shape-neutral-ghost-background-pressed hover:text-shape-neutral-ghost-foreground-default-hover active:bg-shape-neutral-filled-background-pressed data-[loading=true]:bg-shape-neutral-filled-background-pressed bg-transparent",
        critical:
          "bg-shape-critical-inverted-background text-shape-critical-inverted-foreground-default hover:bg-shape-critical-inverted-background-hover active:bg-shape-critical-inverted-background-pressed data-[loading=true]:bg-shape-critical-inverted-background-pressed shadow-xs",
      },
      size: {
        larger: "h-11 gap-2 px-4 text-sm",
        default: "h-9 gap-2 px-4 text-sm",
        smaller:
          "h-6 gap-1.5 px-2 text-sm [&>svg:not([class*='size-'])]:size-[14px]",
        "larger-icon": "size-11",
        icon: "size-9",
        "smaller-icon": "size-6 [&>svg:not([class*='size-'])]:size-[14px]",
        unstyled: "",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
